import container from './ConfirmationModal.container';
import component from './ConfirmationModal';
export default container(component);
